export enum ParameterNameEnum {
    PROCEDURE_ACCEPT_SESSION = "PROCEDURE_ACCEPT_SESSION", // PROCEDIMENTO_ACEITA_SESSÃO
    CONTROL_SESSION = "CONTROL_SESSION", //CONTROLA_SESSION
    INSURACE_ENROLLMENT_MASK = "INSURACE_ENROLLMENT_MASK", // MASCARA_DE_MATRICULA
    SESSION_AS_BLOCKED = "SESSION_AS_BLOCKED", // LANÇAR_BLOQUEADO
    BLOCK_ALL_GUIDES = "BLOCK_ALL_GUIDES", // EXIBIR_BOTÃO_BLOQUEAR_TODAS_AS_GUIAS
    WORKS_ON_SATURDAY = "WORKS_ON_SATURDAY", // FUNCIONA_AOS_SÁBADOS
    WORKS_ON_SUNDAY = "WORKS_ON_SUNDAY", //FUNCIONA_AOS_DOMINGOS
    REQUIRED_ENROLLMENT = "REQUIRED_ENROLLMENT", // MATRICULA_OBRIGATÓRIA
    REQUIRED_PLAN = "REQUIRED_PLAN", //PLANO_OBRIGATÓRIO
    REQUIRED_VALIDITY_ENROLLMENT = "REQUIRED_VALIDITY_ENROLLMENT", //VALIDADE_MATRICULA_OBRIGATÓRIO
    USE_ACCREDITATION_VALUE = "USE_ACCREDITATION_VALUE", //USAR_VALORES_DO_CREDENCIAMENTO
    QUESTION_ON_LACK = "QUESTION_ON_LACK", //ATENDE_NA_CARÊNCIA
    WEBSERVICE_REQUEST_PASSWORD = "WEBSERVICE_REQUEST_PASSWORD", //SOLICITAÇÃO_DE_SENHA
    INSURANCE_PASSWORD_MASK = "INSURANCE_PASSWORD_MASK", //MASCARA_SENHA_AUTORIZAÇÃO
    BLOCKING_REASON = "BLOCKING_REASON", // MOTIVO_DE_BLOQUEIO
    REQUIRED_GENDER = "REQUIRED_GENDER", // GENERO_OBRIGATORIO
    CPF_IGNORED = "00000000515", // CPF_IGNORADO
    CPF_NOT_REQUIRED = "CPF_NOT_REQUIRED", // CPF_IGNORADO
    EXAME_TYPE_PROCEDURE = "EXAME_TYPE_PROCEDURE", // TIPO_ATENDIMENTO_PADRÃO_PROCEDURE
    EXAME_TYPE_ACCREDITATION = "EXAME_TYPE_ACCREDITATION", // TIPO_ATENDIMENTO_PADRÃO_ACCREDITATION
    ROOM_CONTROL_ON_APPOINTMENT = "ROOM_CONTROL_ON_APPOINTMENT", // TIPO_ATENDIMENTO_PADRÃO_ACCREDITATION
    REQUESTER_FIRM_REQUIRED = "REQUESTER_FIRM_REQUIRED", // FIRMA_SOLICITANTE_OBRIGATORIO
    REQUESTER_REQUIRED = "REQUESTER_REQUIRED", // SOLICITANTE_OBRIGATORIO
    PATIENT_HEIGHT = "PATIENT_HEIGHT", // ALTURA_DO_PACIENTE
    PATIENT_WEIGHT = "PATIENT_WEIGHT", // PESO_DO_PACIENTE
    PATIENT_IMC = "PATIENT_IMC", // IMC_DO_PACIENTE
    PROCEDURE_REQUIRED_PROFESSIONAL_REQUESTER = "PROCEDURE_REQUIRED_PROFESSIONAL_REQUESTER", // PROCEDIMENTO_OBRIGATÓRIO_PROFISSIONAL_SOLICITANTE
    DEFAULT_ROLE_MESSAGE = "DEFAULT_ROLE_MESSAGE", //PERFIL_PADRÃO_PARA_MENSAGEM
    WEBSERVICE = "WEBSERVICE", // WEBSERVICE_USADO_PELO_CONVÊNIO
    USE_DB_DIAGNOSTIC = "USE_DB_DIAGNOSTIC", // USA_DB_DIAGNOSTICO
    USE_LAB_CHEKAP = "USE_LAB_CHEKAP", // USA_labchekap
    USE_LAB_ALVARO = "USE_LAB_ALVARO", // USA_labalvaro
    ACCREDITATION_PROFESSIONAL_SOLIC = "ACCREDITATION_PROFESSIONAL_SOLIC", //PROFISSIONAL_SOLICITANTE_CREDENCIAMENTO
    VIA_ACCESS_ACCREDITATION = "VIA_ACCESS_ACCREDITATION", //VIA_DE_ACESSO
    DISPLAY_PHONE_SCHEDULE = "DISPLAY_PHONE_SCHEDULE", //EXIBIR_TELEFONE_AGENDAMENTO
    ONLY_PATIENT_CARE = "ONLY_PATIENT_CARE", //SOMENTE_ATENDIMENTO_DO_PACIENTE
    DO_NOT_DISPLAY_PATIENT_PHONE = "DO_NOT_DISPLAY_PATIENT_PHONE", //NÃO_EXIBIR_TELEFONE_PACIENTE
    VIEW_EVOLUTION_STATUS = "VIEW_EVOLUTION_STATUS", //EXIBIR_STATUS_DA_EVOLUÇÃO
    HIDE_STATUS_PRIORITY_SCHEDULE = "HIDE_STATUS_PRIORITY_SCHEDULE", //ESCONDER_STATUS_DE_PRIORIDADE_DA_AGENDA
    STATUS_ATTEND_IF_ANAMNESE = "STATUS_ATTEND_IF_ANAMNESE", //ESCONDER_STATUS_DE_PRIORIDADE_DA_AGENDA
    HIDE_VALUE_REPORT_PROFESSIONAL = "HIDE_VALUE_REPORT_PROFESSIONAL", //ESCONDER_VALOR_RELATÓRIO_PROFISSIONAL
    SHOW_PRINT_CONFIRM_SCHEDULE = "SHOW_PRINT_CONFIRM_SCHEDULE", //EXIBIR_SE_QUER_IMPRIMIR_CONFIRMAÇAO_DA_AGENDA
    REQUIRED_CID = "REQUIRED_CID", //CID_OBRIGATORIO
    USE_SULAMERICA = "USE_SULAMERICA", // USA_SULAMERICA
    SHOW_WHATSAPP_SCHEDULE = "SHOW_WHATSAPP_SCHEDULE", //EXIBIR_SE_QUER_ENVIAR_WHATSAPP_DA_AGENDA
    SHOW_ALERT_PATIENT = "SHOW_ALERT_PATIENT",
}
